module.exports = __webpack_public_path__ + "img/cx.a434363.svg";